// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"2bb5e38e","453":"19e946da","483":"6e2fff6c"}[chunkId] + ".chunk.js";
};